import { OrderFulfillmentState } from "./orderFulfillment.types";

export const state: OrderFulfillmentState = {
  loading: false,
  orders: [],
  pagination: null,
  details: null
};
